/**
 * @generated SignedSource<<b90bbc26110148abc5e7292a42c9ce7f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type morningStudioArticleContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"globalCheckerContent" | "headerMorningStudioArticle">;
  readonly " $fragmentType": "morningStudioArticleContent";
};
export type morningStudioArticleContent$key = {
  readonly " $data"?: morningStudioArticleContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"morningStudioArticleContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "morningStudioArticleContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerMorningStudioArticle"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "29d82107695097c2c4547397eb7b887c";

export default node;
